import React from 'react';
import PDF from 'components/general/PDF/PDF';
import Article from './containers/Article';

const ArticleSinglePDF = () => (
  <PDF.Section>
    <Article />
  </PDF.Section>
);

export default ArticleSinglePDF;
